import { createContext } from 'react'

const HealthTeamContext = createContext()

export default HealthTeamContext
